import { ComponentIds } from '@inter-ikea-core/core';
import { OutlinedComponent } from '@inter-ikea-core/core';
import IgnoreHighlightComponent from '../components/IgnoreHighlightComponent';
import { PlannerEcsSystem } from './System';
import RedOutlineComponent from '../components/RedOutlineComponent';
/**
 * Highlight added entity with a blue outline
 */
export class HighlightAddedEntitySystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'HighlightAddedEntitySystem', ComponentIds.LOADED_MODEL_INFO_COMPONENT_ID);
    }
    onAdd() { }
    onUpdate(entity, oldComponent, newComponent) {
        if (!this.isEnabled)
            return;
        if (newComponent &&
            newComponent.hasFinishedLoading &&
            !entity.hasComponent(IgnoreHighlightComponent.id) &&
            !entity.hasComponent(ComponentIds.PROPPING_COMPONENT_ID) &&
            !this.coreApi.scene?.selectionSystemDisabled &&
            this.coreApi.entities.getByComponent(RedOutlineComponent.id).length === 0) {
            this.highlight(entity);
        }
    }
    onRemove() { }
    highlight(entity) {
        if (!this.isEnabled)
            return;
        if (entity.hasComponent(ComponentIds.OUTLINED_COMPONENT_ID)) {
            return;
        }
        entity.addComponent(new OutlinedComponent());
        setTimeout(() => {
            if (entity.isDisposed)
                return;
            entity.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
        }, 750);
    }
}
//# sourceMappingURL=HighlightAddedEntitySystem.js.map